import type { CartCoupon } from '@src/domains/coupons/types/coupon';

export type CouponLike = Partial<Pick<CartCoupon, 'code' | 'invalid'>>;

export const isCouponValid = (coupon: CouponLike | null | undefined): coupon is CouponLike & { code: string } =>
  Boolean(coupon?.code) && !coupon?.invalid;
